import FunderListCollaboratorPermissions from "@/enums/FunderListCollaboratorPermissions";
import User from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import { SimpleUser } from "@/models/LazoCompany";
import { Investor } from "@/models/crunchbase/Investor";
import { Organization } from "@/models/crunchbase/Organization";
import { Person } from "@/models/crunchbase/Person";
import AuditableEntity from "./AuditableEntity";

export interface FunderList extends AuditableEntity {
  id: number;
  name: string;
  types: string[];
  entries: number;
  funders: Funder[];
  owner: SimpleUser;
  collaborators: FunderListCollaborator[];
  recommended: boolean;
  fixed: boolean;
  collaboratorsSize: number;
  totalFunders: number;
  totalOrganizations: number;
  totalInvestors: number;
  totalPeople: number;
  tenantExternalId?: string;
}

export interface Funder<T = undefined | Person | Investor | Organization> extends AuditableEntity {
  createdAt?: string;
  externalId: string;
  uuid: string;
  type: FunderType;
  entity?: T;
  hasChildren?: boolean;
  hasParent?: boolean;
  notes: FunderNote[];
  assignedNotes: FunderNote[];
  nextContacts: NextContact[];
  assignedNextContacts: NextContact[];
  closed?: string;
  committed?: string;
  referrer?: string;
  stage?: string;
  isInList?: boolean;
  companyAdditionalFields?: CompanyAdditionalFields;
  investorAdditionalFields?: InvestorAdditionalFields;
  isLazoFunder: boolean;
  creator?: User;
  privacy?: FunderPrivacy;
  email?: string;
  phoneNumber?: string;
}

export interface CreateFunderList extends FunderList {
  funders: Funder[];
}

export interface FunderListCollaborator extends AuditableEntity {
  user: User;
  funderList: FunderList;
  accessType: FunderListCollaboratorPermissions;
}

export enum FunderType {
  ORGANIZATION = "ORGANIZATION",
  INVESTOR = "INVESTOR",
  PERSON = "PERSON",
}

export enum FunderPrivacy {
  TEAM = "TEAM",
  JUST_ME = "JUST_ME",
  PUBLIC = "PUBLIC",
}

export interface FunderNote extends AuditableEntity {
  content: string;
  author: SimpleUser;
  person?: Person;
}

export interface NextContact extends AuditableEntity {
  author?: SimpleUser;
  content?: string;
  date?: Date;
  person?: Person;
}

interface CompanyAdditionalFields {
  investmentCount: number;
}
interface InvestorAdditionalFields {
  organizationFoundedCount: number;
}
